import { checklistAddAction } from '../checklists/actions/checklistAddAction';
import { IChecklist } from '../checklist/types';
import { checklistsActionSetAction } from '../../actions/checklistsActionSetAction';

export const checklistAddStore = (
    checklist: IChecklist
) => {
    return checklistsActionSetAction(checklistAddAction(checklist));
};
